<template>
  <component
    :is="filtro.default ? 'InputText' : 'ExibicaoInputText'"
    v-bind="componentProps"
    v-model:text="text"
    @aplicarFiltro="aplicarFiltro"
    @excluded="excluirFiltro"
  />
</template>
<script>
import ExibicaoInputText from '../../components/ExibicaoInputText.vue';
import InputText from '../../components/InputText.vue';
import mixinFiltro from '../../mixins/mixinFiltro';
export default {
  emits: ['excluirFiltro'],
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputText,
    ExibicaoInputText
  },
  computed: {
    componentProps() {
      return {
        filtro: this.filtro,
        path: this.path,
        ...(this.filtro.default ? {} : { campo: this.filtro }),
      };
    },
  },
  mixins: [mixinFiltro],
}
</script>
